import React from 'react';
import { useSelector } from 'react-redux';
import { SimpleFlexbox, Picture, CrossSell } from 'ctm-components';
import { useBrandContentFactory } from 'ctm-app/client/hooks/useBrandContentFactory';
import styles from './shielded.css';
import { shieldedThankYouHeroImageSelector } from '../../../core/state_selectors';

const ThankYou = () => {
    const heroImageUrl = useSelector(shieldedThankYouHeroImageSelector);
    const contentFactory = useBrandContentFactory();
    const hasUpsellEnabled = contentFactory.crossSellOtherVerticalsOnResults();

    return (
        <>
            <SimpleFlexbox display="flex" column variant="text_align_center" className={styles.thank_you_container}>
                <h1>Thank you</h1>
                <h3>Shielded has received your details and will be in touch shortly.</h3>
                {heroImageUrl !== null && <Picture className={styles.meerkats} src={heroImageUrl} alt="hero image" />}
                {hasUpsellEnabled  && <p>In the meantime, why not compare your other insurances and utilities to see if you can find a better deal.</p>}
            </SimpleFlexbox>
            {hasUpsellEnabled && <CrossSell variant="large_spacing" />}
        </>
    );
};

export { ThankYou };
